import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, Renderer2, ElementRef, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { GeneralService } from 'src/app/services/general.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { ECallScriptSections } from '../enum';
import { UserSessionService } from 'src/app/services/usersession.service';
import { CallScriptService } from 'src/app/services/call-script.service';
import { CommonMethodService } from '../common-method.service';

@Component({
    selector: 'app-existing-contact',
    templateUrl: 'existing-contact.component.html',
    styleUrls: ['existing-contact.component.scss'],
    standalone: false
})

export class ExistingContactComponent implements OnInit {
    isExistingContactOpen = false;
    section = ECallScriptSections.MatchingContact;    

    @Input() isQuickStart;
    @Input() existingContactList;
    @Output() selectTenant = new EventEmitter();
    @Output() dismissMatchedContactPopup = new EventEmitter();
    @ViewChild('existingContactTemplate', { static: true }) existingContactTemplate: ModalDirective;
    existingContactId = '';
  isScreenPopup: boolean = false;
  hoveredItem: any = null;
modalConfig = {
  backdrop: 'static'
};
    constructor(
        private modalService: BsModalService,
        public generalService: GeneralService,
        private render: Renderer2,
        private element: ElementRef,
        private facOpsDataService: FacOpsDataService,
        private commonMethod: CommonMethodService) { }

    ngOnInit() {
      this.isScreenPopup = this.facOpsDataService?.isFromScreenPopup ?? false;
    }

    getExistingContact(eve, listItem) {
        if (!eve.target.classList.contains('add_prospect_list')) {
            this.generalService.IsExistingcustomer = true;
            var tenantId = listItem.TenantId;
            if (tenantId && tenantId > 0) {
                this.generalService.isMatchingContactSelected = true;
                this.commonMethod.UpdateTenantIdforLocalStorage(tenantId);
                this.selectTenant.emit(listItem);
            }
            this.existingContactTemplate.hide();
            this.isExistingContactOpen = false;
            this.facOpsDataService.setCurrentType(ECallScriptSections.Prospect, false);
        }
    }

    openExistingModal() {
        this.closeAllToggleGroups();
        this.facOpsDataService.isScriptDataPresent(this.section, false, false, this.isScreenPopup);
        this.existingContactTemplate.show();
        this.isExistingContactOpen = true;
        this.facOpsDataService.setCurrentType(this.section, true);
    }

    cancelExistingTenant(val) {
        this.generalService.IsExistingcustomer = false;
        this.generalService.isMatchingContactSelected = false;
        this.generalService.setStopMatchingPopupStatus(true);
        this.commonMethod.UpdateTenantIdforLocalStorage(val)
        this.selectTenant.emit(val);
        this.existingContactTemplate.hide();
        this.isExistingContactOpen = false;
        this.facOpsDataService.setCurrentType(ECallScriptSections.Prospect, false);
    }

    hidepopup() {
        if (this.existingContactTemplate) {
            this.existingContactTemplate.hide();
        }
        this.isExistingContactOpen = false;
        this.facOpsDataService.setCurrentType(ECallScriptSections.Prospect, false);
    }

    getRowClass(index, tenantId) {
        const tenID = 'Cls' + tenantId.toString() + ' displayRow';
        if (index !== 0) {
          return tenID;
        } else {
          return '';
        }
    }
    
    toggleButton(ref, calssName) {
      const rowClass = '.' + 'Cls' + calssName;
      const elements = this.element.nativeElement.querySelectorAll(rowClass);
      const reference = ref.target.classList.contains('open');
      if (reference) {
        this.render.removeClass(ref.target, 'open');
        elements.forEach(element => {
          element.style.display = 'none';
        });
      } else {
        this.render.addClass(ref.target, 'open');
        elements.forEach(element => {
          element.style.display = 'table-row';
        });
      }
    }

    closeAllToggleGroups() {
      setTimeout(() => {
        const nativeElement = this.element.nativeElement;
        const toggleGroups = nativeElement.querySelectorAll('[class*="Cls"]');
        const toggles = nativeElement.querySelectorAll('.add_prospect_list');
        toggleGroups.forEach((group: HTMLElement) => {
          group.style.display = 'none';
        });
        toggles.forEach((toggle: HTMLElement) => {
          this.render.removeClass(toggle, 'open');
        });
      },300)
    }

    closeExistingModal(){
      this.existingContactTemplate.hide();
      this.dismissMatchedContactPopup.emit();
    }
}
